<div #autocompleteRef
  class="autocomplete"
  [class.light]="theme === 'light'"
  [class.dark]="theme === 'dark'"
  [class.analyst-studio]="isAnalystStudio$ | async"
></div>
